import { Component, ElementRef, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductImageZoomProductImagesComponent } from '@spartacus/product/image-zoom/components';
import { CurrentProductService, LaunchDialogService } from '@spartacus/storefront';
import { Subscription, combineLatest } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { KbCustomImageZoomComponent } from './kb-custom-image-zoom/kb-custom-image-zoom/kb-custom-image-zoom/kb-custom-image-zoom.component';
import { LAUNCH_CALLER } from '../lauch-caller.enum';



@Component({
  selector: 'kb-product-image-zoom',
  templateUrl: './kb-product-image-zoom.component.html',
  standalone: false
})
export class KbProductImageZoomProductImagesComponent extends ProductImageZoomProductImagesComponent {
  currentProduct$ = this.currentProductService.getProduct();
  protected subscriptions = new Subscription();
  @ViewChild('expandButton') expandButton: ElementRef;
  @Output() dialogClose = new EventEmitter<void>();
  constructor(
    protected override currentProductService: CurrentProductService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    public dialog: MatDialog
  ) {
    super(currentProductService);

  }
  hasExtraImageTypes(main: any): boolean {
    return !!(main.cartIcon || main.thumbnail || main.zoom);
  }
  imageUrl: any;
  openImageDialog() {
    /* let galleryImages
      this.subscriptions.add(this.currentProduct$.subscribe(product => {
       console.log("prod", product);
       galleryImages = product?.images?.['GALLERY'][0]?.plmMaster?.url;
     }));
     if (galleryImages) {
       this.dialog.open(KbCustomImageZoomComponent, {
         data: {
           imageUrl: galleryImages
         },
         panelClass: 'custom-imgaeZoom'
       });
     } */
    let galleryImages: string | undefined;
    // Get the image once
    const sub = this.currentProduct$.pipe(take(1)).subscribe(product => {
      galleryImages = product?.images?.['GALLERY']?.[0]?.plmMaster?.url;
      this.imageUrl = galleryImages!;
    });
    this.subscriptions.add(sub);

    if (!galleryImages) return;

    // Open dialog *inside the same click gesture*
    const dialogRef = this.dialog.open(KbCustomImageZoomComponent, {
      data: { imageUrl: galleryImages },
      panelClass: 'custom-imgaeZoom', // keep your exact spelling
      disableClose: false,
    });

    // Synchronously try native fullscreen on the dialog container element
    const containerEl = (dialogRef as any)._containerInstance?._elementRef?.nativeElement as HTMLElement | undefined;
    if (containerEl) {
      try {
        const req =
          containerEl.requestFullscreen ||
          (containerEl as any).webkitRequestFullscreen ||
          (containerEl as any).msRequestFullscreen;

        const p = req?.call(containerEl);
        p?.catch(err => {
          console.warn('[IMG FS] container FS denied:', err);
          // Fallback: pseudo-FS on the dialog
          dialogRef.componentInstance?.applyPseudoFullscreenFromLauncher?.();
        });
      } catch (err) {
        console.warn('[IMG FS] container FS threw:', err);
        dialogRef.componentInstance?.applyPseudoFullscreenFromLauncher?.();
      }
    } else {
      // Fallback if we can't reach the container yet
      dialogRef.afterOpened().subscribe(() => {
        dialogRef.componentInstance?.applyPseudoFullscreenFromLauncher?.();
      });
    }

    // Center the image after open
    dialogRef.afterOpened().subscribe(() => {
      dialogRef.componentInstance?.fitToScreen();
    });

  }
  trigger360Zoom() {
    const component = this.launchDialogService.launch(
      LAUNCH_CALLER.PRODUCT_360View_IMAGE_ZOOM,
      this.vcr
    );
    if (component) {
      this.subscriptions.add(
        combineLatest([component, this.launchDialogService.dialogClose])
          .pipe(
            filter(([, close]) => Boolean(close)),
            tap(([comp]) => {
              this.launchDialogService.clear(LAUNCH_CALLER.PRODUCT_360View_IMAGE_ZOOM);
              comp?.destroy();
              this.dialogClose.emit();
              this.expandButton?.nativeElement?.focus();
            })
          )
          .subscribe()
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
